import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPAdvancePaymentActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Advance/AdvanceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPAdvancePayment"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPAdvancePayment"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPAdvancePaymentActivity)
